"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeTheme = void 0;
function mergeTheme(currentTheme, themeOverride) {
    if (!themeOverride) {
        return currentTheme;
    }
    // @ts-ignore
    return Object.keys(currentTheme).reduce(function (acc, key) {
        if (key === 'headings' && themeOverride.headings) {
            var sizes = themeOverride.headings.sizes
                ? Object.keys(currentTheme.headings.sizes).reduce(function (headingsAcc, h) {
                    // eslint-disable-next-line no-param-reassign
                    headingsAcc[h] = __assign(__assign({}, currentTheme.headings.sizes[h]), themeOverride.headings.sizes[h]);
                    return headingsAcc;
                }, {})
                : currentTheme.headings.sizes;
            return __assign(__assign({}, acc), { headings: __assign(__assign(__assign({}, currentTheme.headings), themeOverride.headings), { sizes: sizes }) });
        }
        acc[key] =
            typeof themeOverride[key] === 'object'
                ? __assign(__assign({}, currentTheme[key]), themeOverride[key]) : themeOverride[key] || currentTheme[key];
        return acc;
    }, {});
}
exports.mergeTheme = mergeTheme;
